import { CandidateService } from 'src/app/_services/candidate.service';
import { TalentpoolService } from '../../_services/talentpool.service';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { Component, OnInit, TemplateRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
declare const clevertap;

@Component({
  selector: 'app-create-talentpool',
  templateUrl: './create-talentpool.component.html',
  styleUrls: ['./create-talentpool.component.scss']
})
export class CreateTalentpoolComponent implements OnInit {

  talentpool_form: FormGroup;
  success_message: string;
  talentpooldetails: any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() TalentpoolIDtoEdit: any;

  @ViewChild('successModal') successModal: TemplateRef<any>;
  @ViewChild('errorModal') errorModal: TemplateRef<any>;

  constructor(private fb: FormBuilder, private talentpoolservice: TalentpoolService, public modalService: NgbModal, private candidateservice: CandidateService,
    private _localstorageservice: LocalStorageService) { }

  ngOnInit() {
    this.talentpool_form = this.fb.group({
      talentpoolname: ['', [Validators.required, noWhitespaceValidator , Validators.pattern(/^(?!.*<[^>]+>).*/i)]],
      talentpooldescription: ['', [Validators.required, noWhitespaceValidator , ValidateHTMLTAGS]]
    })

    function noWhitespaceValidator(control: AbstractControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'required': true };
    }

    function ValidateHTMLTAGS(control: AbstractControl){
      if(control.value){
        const res = control.value.replace(/ /g, '')
        let scriptRegex = /<(.*)>/g;
        if(res && (scriptRegex.test(res.trim()) == true)){
          return { 'pattern': true }
        }else{
          return null
        }
      }
    }

    if (this.TalentpoolIDtoEdit) {
      this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
        if (res.status == 'success') {
          this.talentpooldetails = res.data.talentpools.filter((x) => { return x.talentpoolnumber == this.TalentpoolIDtoEdit })[0]
        }
        this.talentpool_form.patchValue({
          talentpoolname: this.talentpooldetails.name,
          talentpooldescription: this.talentpooldetails.description
        })
      })
    }

  }

  createTalentpool() {
    if (this.talentpool_form.valid) {
      let data = {
        talentpoolnumber: this.talentpooldetails ? this.talentpooldetails.talentpoolnumber : null,
        name: this.talentpool_form.value.talentpoolname,
        description: this.talentpool_form.value.talentpooldescription,
        usernumber: this._localstorageservice.getItem('usernumber')
      }

      if (this.TalentpoolIDtoEdit) {
        this.talentpoolservice.updateTalentpoolDetails(data).subscribe((res: any) => {
          if (res.status == 'success') {
            // this.success_message = "Talentpool Updated Successfully";
            // const modalRef = this.modalService.open(this.successModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
            this.modalService.dismissAll();
            this.talentpoolservice.createTalentpoolData();
            this.passEntry.emit('talentpool-edited');
          }
        })
      }
      else {
        this.talentpoolservice.createTalentpool(data).subscribe((res: any) => {
          if (res.status == 'success') {
            // this.success_message = "Talentpool Created Successfully";
            // const modalRef = this.modalService.open(this.successModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
            this.modalService.dismissAll();
            this.passEntry.emit('talentpool-added');
            this.candidateservice.createCandidateData();
            // this.talentpoolservice.createTalentpoolData();
            //- Clevertap Create Talentpool event
            let ctObj = {
              "Name": data.name,
            }
            this.cleverTapEvent("Create Talentpool", ctObj);
          } else if (res.status == 'failure' && res.message == 'insufficient credits') {
            this.passEntry.emit('notpcredits');
          }
        })
      }
    }
    else {
      this.validateAllFormFields(this.talentpool_form)
    }

  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  dismiss() {
    this.modalService.dismissAll();
  }

  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }
}
